const OurWork = [
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/OurWork/Trailer.jpeg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/OurWork/Trailer2.jpeg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
    cols: 1,
  },
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
    cols: 1,
  },
];
export default OurWork;
